import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { LoyaltySystem } from '../../models/loyalty-system.model';
import 'rxjs/Rx';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class LoyaltySystemService {

  items: LoyaltySystem[];
  itemEditing: LoyaltySystem;
  private cachedFields: Observable<any>;

  constructor(
    private h: HttpClientService,
    private srvNotify: MessageService,
    private translate: TranslateService
  ) { }

  private notifySuccess() {
    this.translate.get(['common.success', 'common.operation_success']).subscribe(res => {
      this.srvNotify.add({ severity: 'info', summary: res['common.success'], detail: res['common.operation_success'] });
    });
  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<any> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged('/koncentro-common/loyalty' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }

  getAll() {
    return this.h.get('/koncentro-common/loyalty')
      .map(res => {
        return this.items = res;
      });
  }

  getById(id) {
    return this.h.get('/koncentro-common/loyalty/' + id);
  }

  delete(record) {
    return this.h.delete('/koncentro-common/loyalty/' + record.id)
      .map(res => {
        this.notifySuccess();
      });
  }

  post(newData, silent = false) {
    return this.h.post('/koncentro-common/loyalty', newData, silent)
      .map(res => {
        newData.id = res.id;
        this.notifySuccess();
      });
  }

  put(newData, silent = false) {
    return this.h.put('/koncentro-common/loyalty/' + newData.id, newData, silent)
      .map(res => {
        Object.assign(this.itemEditing, newData);
        this.notifySuccess();
      });
  }

  recover(record) {
    const data = Object.assign({}, record, { flg_state: 0 });
    return this.h.put('/koncentro-common/loyalty/' + record.id, data)
      .map(res => {
        this.notifySuccess();
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/LoyaltyDto').pipe(
        publishReplay(1),
        refCount()
      );
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty-system/loyalty-system.service.ts